import { render, staticRenderFns } from "./manage-booking-main-section.vue?vue&type=template&id=078c4a5e&scoped=true"
import script from "./manage-booking-main-section.vue?vue&type=script&lang=ts"
export * from "./manage-booking-main-section.vue?vue&type=script&lang=ts"
import style0 from "./manage-booking-main-section.vue?vue&type=style&index=0&id=078c4a5e&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078c4a5e",
  null
  
)

export default component.exports